import Crud from '../views/Discipline/Crud'
import Entity from '../views/Discipline/Add'

let routes = {
    path: '/discipline',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/discipline/add',
            name: 'NewSubject',
            component: Entity,
            meta: {
                pageTitle: 'discipline.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'discipline.form.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/discipline/edit/:id?',
            name: 'EditSubject',
            component: Entity,
            meta: {
                pageTitle: 'discipline.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'discipline.form.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/discipline',
            name: 'list-discipline',
            component: Crud,
            meta: {
                pageTitle: 'discipline.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'discipline.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
